import type { PropsWithChildren as PWC } from 'react';
import { Navigate } from 'react-router-dom';

import { useFlags } from '../../hooks/use-flags';
import type { EnhancedFillFlowFlag } from '../../types/non-boolean-flags';
import { getAbsoluteRoute } from '../../util/get-absolute-route';

export const EnhancedFillFlagCheck = ({ children }: PWC) => {
    const { enableEnhancedFillFlow } = useFlags();

    const flagValue = enableEnhancedFillFlow as EnhancedFillFlowFlag;

    if (flagValue.drugKeys.length || flagValue.ndcs.length) {
        return <>{children}</>;
    }

    return <Navigate to={getAbsoluteRoute('root')} />;
};
